import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import DataModel from "./sopDataModel";

import { Deeds } from "./sopDataTemplate";
interface AllProps {
  data: Deeds;
  handleDeedChange: any;
}

export class Deed extends Component<AllProps> {
  state = {
    isOptionOpen: false,
    bgColor: "#ffff8d",
    responseData: {},
    isUpdateAvailable: false,
  };

  componentDidMount() {
    const { data } = this.props;
    this.setState({
      responseData: JSON.parse(JSON.stringify(data)),
    });
  }

  changeBgColor = () => {
    const { bgColor } = this.state;
    if (bgColor !== "lightgreen") {
      this.setState({ bgColor: "lightgreen" });
    }
  };
  handleChange = (name, val) => {
    const { data } = this.props;
    data[name] = val;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleDeedChange(data);
    this.setState({
      isUpdateAvailable: !this.state.isUpdateAvailable,
    });
  };
  handleChildInputChange = (key, name, value, index?) => {
    // console.log("key & value", `${key}-${name}`);
    const { data } = this.props;
    if (index !== undefined) data[key][index][name] = value;
    else data[key][name] = value;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleDeedChange(data);
    this.setState({
      isUpdateAvailable: !this.state.isUpdateAvailable,
    });
  };
  handleChildRadioChange = (key, name, val, index?) => {
    // console.log("key & value", `${key}-${name}`);
    const { data } = this.props;
    if (index !== undefined) {
      data[key][index][name] = val;
    } else {
      data[key][name] = val;
    }
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleDeedChange(data);
    this.setState({
      isUpdateAvailable: !this.state.isUpdateAvailable,
    });
  };

  checkOperation = (type, value, index) => {
    let isEditable = false;
    const { responseData } = this.state;
    if (responseData[type] && responseData[type].length < index + 1) {
      isEditable = true;
    }
    return isEditable;
  };

  addChild = (type) => {
    const { data } = this.props;
    if (type == "saleDeed") {
      data[type].push({
        saleDeedAmountTransfered: false, // Changed from null to false
        saleDeedConditionsMentioned: false, // Changed from null to false
      });
    } else if (type == "giftDeed") {
      data[type].push({
        derivedBy: "",
        registered: false, // Changed from null to false
        condition: false, // Changed from null to false
        conditionFulfilled: false, // Changed from null to false
        mentionCondition: "",
      });
    } else if (type == "settlementDeed") {
      data[type].push({
        derivedBy: "",
        registered: false, // Changed from null to false
        condition: false, // Changed from null to false
        conditionFulfilled: false, // Changed from null to false
        deathcertificateobtained: false, // Changed from null to false
        relationshipMentioned: false, // Changed from null to false
        mentionCondition: "",
      });
    } else if (type == "partitionDeed") {
      data[type].push({
        derivedBy: "",
        registered: false, // Changed from null to false
        condition: false, // Changed from null to false
        conditionFulfilled: false, // Changed from null to false
        mentionCondition: "",
        docAllotedForMortgage: "",
        originalCopyAvailable: "",
        partiondeathcertobtin: false, // Changed from null to false
        partionscheduleMortage: false, // Changed from null to false
        partionRelationship: false, // Changed from null to false
        partionsimulatenous: false, // Changed from null to false
      });
    } else if (type == "willDeed") {
      data[type].push({
        derivedBy: "",
        registered: false, // Changed from null to false
        condition: false, // Changed from null to false
        conditionFulfilled: false, // Changed from null to false
        mentionCondition: "",
        willdeedcertcopyverify: false, // Changed from null to false
        willdeaddeathcert: false, // Changed from null to false
        willdeadreationship: false, // Changed from null to false
      });
    } else if (type == "leaseDeed") {
      data[type].push({
        leasePeriodFromDate: "",
        leasePeriodToDate: "",
        nocAvailable: false, // Changed from null to false
        leaseDeedempowermortage: false, // Changed from null to false
        leaseDeedCancellation: false, // Changed from null to false
      });
    } else if (type == "attorneyDeed") {
      data[type].push({
        derivedBy: "",
        registered: false, // Changed from null to false
        isInForce: false, // Changed from null to false
        isCertifiedCopyAvailable: false, // Changed from null to false
        attorneyDeedmortage: false, // Changed from null to false
        attorneyDeedsaleReceipt: false, // Changed from null to false
        attorneyLifecert: false, // Changed from null to false
      });
    } else if (type == "releaseDeed") {
      data[type].push({
        derivedBy: "",
        registered: false, // Changed from null to false
        condition: false, // Changed from null to false
        fulFilled: false, // Changed from null to false
        propertyshare: "",
        mentionCondition: "",
        deatcertficate: false, // Changed from null to false
        relationShipmentioned: false, // Changed from null to false
      });
    } else if (type == "rectificationDeed") {
      data[type].push({
        derivedBy: "",
        registered: false, // Changed from null to false
        mentionDetails: "",
        correctDetails: "",
      });
    } else if (type == "consentDeed") {
      data[type].push({
        derivedBy: "",
        registered: false, // Changed from null to false
        reason: "",
        agecheckAadhar: false, // Changed from null to false
      });
    } else if (type === "missingDocument") {
      if (!Array.isArray(data[type])) {
        data[type] = [];
      }

      data[type].push({
        policeComplaint: false,
        paperAd: false,
        tracableCertificate: false,
        NoClaimcertificate: false,
      });
    } else {
      // data[type].push({
      //     ...JSON.parse(JSON.stringify(DataModel['deed'][type][0]))
      // });
    }
    this.props.handleDeedChange(data);
    this.setState({
      isUpdateAvailable: !this.state.isUpdateAvailable,
    });
  };

  removeChild = (type, index) => {
    const { data } = this.props;
    delete data[type][index];
    this.props.handleDeedChange(data);
    this.setState({
      isUpdateAvailable: !this.state.isUpdateAvailable,
    });
  };

  // getAddButton = (title, value) => {
  //   // console.log("add btn type--->>", `${title}---${value}`);
  //   return (
  //     <div style={{ display: "flex", justifyContent: "space-between" }}>
  //       <h6>
  //         <b>{title}</b>
  //       </h6>
  //       <div onClick={() => this.addChild(value)}>
  //         <button
  //           className="btn btn-sm btn-primary"
  //           style={{ fontSize: "smaller" }}
  //         >
  //           Add {title}
  //         </button>
  //       </div>
  //     </div>
  //   );
  // };
  getAddButton = (
    title: string,
    value: string,
    showRadioForSection?: boolean,
  ) => {
    const { data } = this.props;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <h6 style={{ margin: 0 }}>
            <b>{title}</b>
          </h6>

          {/* Show radio buttons only for the specified section */}
          {showRadioForSection === true && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "20px",
              }}
            >
              <Form.Check
                inline
                label="Yes"
                name={`isshow${value}Status`}
                type="radio"
                id={`isshow${value}Status-yes`}
                checked={data[`isshow${value}Status`] === true}
                onChange={() => {
                  const fieldName = `isshow${value}Status`;
                  data[fieldName] = true;
                  this.changeBgColor();
                  data.bgColor = "lightgreen";
                  this.props.handleDeedChange(data);
                  this.setState({
                    isUpdateAvailable: !this.state.isUpdateAvailable,
                  });
                }}
                style={{ marginRight: "15px" }}
              />
              <Form.Check
                inline
                label="No"
                name={`isshow${value}Status`}
                type="radio"
                id={`isshow${value}Status-no`}
                checked={data[`isshow${value}Status`] !== true}
                onChange={() => {
                  const fieldName = `isshow${value}Status`;
                  data[fieldName] = false;
                  this.changeBgColor();
                  data.bgColor = "lightgreen";
                  this.props.handleDeedChange(data);
                  this.setState({
                    isUpdateAvailable: !this.state.isUpdateAvailable,
                  });
                }}
              />
            </div>
          )}
        </div>

        <div onClick={() => this.addChild(value)}>
          <button
            className="btn btn-sm btn-primary"
            style={{ fontSize: "smaller" }}
          >
            Add {title}
          </button>
        </div>
      </div>
    );
  };

  render() {
    const { data } = this.props;
    const { isOptionOpen, bgColor } = this.state;
    return (
      <div className="collapse-section deed-section">
        <Accordion>
          <Card>
            <Accordion.Toggle
              style={{ background: data.bgColor ? data.bgColor : bgColor }}
              as={Card.Header}
              eventKey="2"
              onClick={() => {
                this.setState({ isOptionOpen: !isOptionOpen });
              }}
            >
              <h5>
                <b>Deed</b>
              </h5>
              <i
                className={`icon feather icon-${
                  !isOptionOpen ? "plus" : "minus"
                }`}
                style={{
                  color: "black",
                  fontSize: "17px",
                  fontWeight: "bold",
                  float: "right",
                }}
              />
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="2">
              <Card.Body>
                <div>
                  {this.getAddButton("Sale Deed", "saleDeed", true)}
                  {data.saleDeed &&
                    data.saleDeed.map((value: any, index: number) => {
                      return (
                        <div className="row">
                          <div className="col-md-5">
                            <label className="label" style={{ padding: 0 }}>
                              Sale Deed Amount Transferred
                            </label>
                          </div>
                          <div className="col-md-6">
                            <Form.Check
                              inline
                              label="Yes"
                              name={`saleDeedAmountTransfered-${index}`}
                              type="radio"
                              checked={value?.saleDeedAmountTransfered === true}
                              onChange={(e) =>
                                this.handleChildRadioChange(
                                  "saleDeed",
                                  "saleDeedAmountTransfered",
                                  true,
                                  index,
                                )
                              }
                            />
                            <Form.Check
                              inline
                              label="No"
                              name={`saleDeedAmountTransfered-${index}`}
                              type="radio"
                              checked={
                                value?.saleDeedAmountTransfered === false
                              }
                              onChange={(e) =>
                                this.handleChildRadioChange(
                                  "saleDeed",
                                  "saleDeedAmountTransfered",
                                  false,
                                  index,
                                )
                              }
                            />
                          </div>
                          <div className="col-md-5">
                            <label className="label" style={{ padding: 0 }}>
                              Conditions Mentioned or Not
                            </label>
                          </div>
                          <div className="col-md-6">
                            <Form.Check
                              inline
                              label="Yes"
                              name={`saleDeedConditionsMentioned-${index}`}
                              type="radio"
                              checked={
                                value?.saleDeedConditionsMentioned === true
                              }
                              onChange={(e) =>
                                this.handleChildRadioChange(
                                  "saleDeed",
                                  "saleDeedConditionsMentioned",
                                  true,
                                  index,
                                )
                              }
                            />
                            <Form.Check
                              inline
                              label="No"
                              name={`saleDeedConditionsMentioned-${index}`}
                              type="radio"
                              checked={
                                value?.saleDeedConditionsMentioned === false
                              }
                              onChange={(e) =>
                                this.handleChildRadioChange(
                                  "saleDeed",
                                  "saleDeedConditionsMentioned",
                                  false,
                                  index,
                                )
                              }
                            />
                          </div>
                          {value?.saleDeedConditionsMentioned === true && (
                            <>
                              <div className="col-md-5">
                                <label className="label" style={{ padding: 0 }}>
                                  Mentione Conditions
                                </label>
                              </div>
                              <div className="col-md-6">
                                <input
                                  className="form-control"
                                  name={
                                    "saleDeedConditions" +
                                    value?.saleDeedConditions +
                                    index
                                  }
                                  type="text"
                                  value={value?.saleDeedConditions}
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "saleDeed",
                                      "saleDeedConditions",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </>
                          )}

                          {this.checkOperation("saleDeed", value, index) && (
                            <div
                              className="form-group col-md-1"
                              style={{
                                alignSelf: "center",
                                fontSize: "initial",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.removeChild("saleDeed", index)
                              }
                            >
                              <i
                                style={{ color: "red" }}
                                className="feather icon-minus-circle"
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
                <hr />
                <div>
                  {this.getAddButton("Gift Settlement Deed", "giftDeed", true)}
                  {data.giftDeed &&
                    Array.isArray(data.giftDeed) &&
                    data.giftDeed.map((value, index) => {
                      return (
                        <div className="row">
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              Executant Derived by
                            </label>
                            <input
                              className="form-control"
                              name={"giftDeed" + value?.derivedBy + index}
                              type="text"
                              value={value?.derivedBy}
                              onChange={(e) =>
                                this.handleChildInputChange(
                                  "giftDeed",
                                  "derivedBy",
                                  e.target.value,
                                  index,
                                )
                              }
                            />
                          </div>
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              Registered?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`giftDeed-registered-${index}`}
                                type="radio"
                                checked={value?.registered === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "giftDeed",
                                    "registered",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`giftDeed-registered-${index}`}
                                type="radio"
                                checked={value?.registered === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "giftDeed",
                                    "registered",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group  col-md-3">
                            <label className="label" style={{ padding: 0 }}>
                              condition?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`giftDeed-condition-${index}`}
                                type="radio"
                                checked={value?.condition === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "giftDeed",
                                    "condition",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`giftDeed-condition-${index}`}
                                type="radio"
                                checked={value?.condition === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "giftDeed",
                                    "condition",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div
                            className="form-group  col-md-4"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Death Certificate Obtained ?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`giftDeed-condition-${index}`}
                                type="radio"
                                checked={
                                  value?.deathcertificateobtained === true
                                }
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "giftDeed",
                                    "deathcertificateobtained",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`giftDeed-condition-${index}`}
                                type="radio"
                                checked={
                                  value?.deathcertificateobtained === false
                                }
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "giftDeed",
                                    "deathcertificateobtained",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div
                            className="form-group  col-md-4"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Relationship Mentioned ?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <input
                                className="form-control"
                                name={
                                  "giftDeedrelationshipMentioned" +
                                  value?.relationshipMentioned +
                                  index
                                }
                                type="text"
                                value={value?.relationshipMentioned}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "giftDeed",
                                    "relationshipMentioned",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          {this.checkOperation("giftDeed", value, index) && (
                            <div
                              className="form-group col-md-1"
                              style={{
                                alignSelf: "center",
                                fontSize: "initial",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.removeChild("giftDeed", index)
                              }
                            >
                              <i
                                style={{ color: "red" }}
                                className="feather icon-minus-circle"
                              />
                            </div>
                          )}
                          {value?.condition === true ? (
                            <>
                              <div
                                className="form-group  col-md-4"
                                style={{ marginBottom: 0 }}
                              >
                                <label className="label" style={{ padding: 0 }}>
                                  condition Fullfilled?
                                </label>
                                <div className="row" style={{ marginLeft: 0 }}>
                                  <Form.Check
                                    inline
                                    label="Yes"
                                    name={`giftDeed-conditionFulfilled-${index}`}
                                    type="radio"
                                    checked={value?.conditionFulfilled === true}
                                    onChange={() =>
                                      this.handleChildRadioChange(
                                        "giftDeed",
                                        "conditionFulfilled",
                                        true,
                                        index,
                                      )
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    label="No"
                                    name={`giftDeed-conditionFulfilled-${index}`}
                                    type="radio"
                                    checked={
                                      value?.conditionFulfilled === false
                                    }
                                    onChange={() =>
                                      this.handleChildRadioChange(
                                        "giftDeed",
                                        "conditionFulfilled",
                                        false,
                                        index,
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              {value?.condition === true && (
                                <>
                                  <div
                                    className="form-group  col-md-8"
                                    style={{ marginBottom: 0 }}
                                  >
                                    <label
                                      className="label"
                                      style={{ padding: 0 }}
                                    >
                                      Mention Condition
                                    </label>
                                    <input
                                      className="form-control"
                                      name={
                                        "giftDeedmentionCondition" +
                                        value?.mentionCondition +
                                        index
                                      }
                                      type="text"
                                      value={value?.mentionCondition}
                                      onChange={(e) =>
                                        this.handleChildInputChange(
                                          "giftDeed",
                                          "mentionCondition",
                                          e.target.value,
                                          index,
                                        )
                                      }
                                    />
                                  </div>
                                </>
                              )}
                            </>
                          ) : null}
                        </div>
                      );
                    })}
                </div>
                <hr />
                <div>
                  {this.getAddButton("Settlement Deed", "settlementDeed", true)}
                  {data.settlementDeed &&
                    Array.isArray(data.settlementDeed) &&
                    data.settlementDeed.map((value, index) => {
                      return (
                        <div className="row">
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              Executant Derived by
                            </label>
                            <input
                              className="form-control"
                              name={
                                "settlementDeedderivedBy" +
                                value?.derivedBy +
                                index
                              }
                              type="text"
                              value={value?.derivedBy}
                              onChange={(e) =>
                                this.handleChildInputChange(
                                  "settlementDeed",
                                  "derivedBy",
                                  e.target.value,
                                  index,
                                )
                              }
                            />
                          </div>
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              Registered?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`settlementDeed-registered-${index}`}
                                type="radio"
                                checked={value?.registered === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "settlementDeed",
                                    "registered",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`settlementDeed-registered-${index}`}
                                type="radio"
                                checked={value?.registered === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "settlementDeed",
                                    "registered",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group  col-md-3">
                            <label className="label" style={{ padding: 0 }}>
                              condition?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`settlementDeed-condition-${index}`}
                                type="radio"
                                checked={value?.condition === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "settlementDeed",
                                    "condition",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`settlementDeed-condition-${index}`}
                                type="radio"
                                checked={value?.condition === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "settlementDeed",
                                    "condition",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          {this.checkOperation(
                            "settlementDeed",
                            value,
                            index,
                          ) && (
                            <div
                              className="form-group col-md-1"
                              style={{
                                alignSelf: "center",
                                fontSize: "initial",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.removeChild("settlementDeed", index)
                              }
                            >
                              <i
                                style={{ color: "red" }}
                                className="feather icon-minus-circle"
                              />
                            </div>
                          )}
                          <div
                            className="form-group  col-md-4"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              condition Fullfilled?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`settlementDeed-conditionFulfilled-${index}`}
                                type="radio"
                                checked={value?.conditionFulfilled === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "settlementDeed",
                                    "conditionFulfilled",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`settlementDeed-conditionFulfilled-${index}`}
                                type="radio"
                                checked={value?.conditionFulfilled === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "settlementDeed",
                                    "conditionFulfilled",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div
                            className="form-group  col-md-4"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Death Certificate Obtained ?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`settlementDeed-deathcertificateobtained-${index}`}
                                type="radio"
                                checked={
                                  value?.deathcertificateobtained === true
                                }
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "settlementDeed",
                                    "deathcertificateobtained",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`settlementDeed-deathcertificateobtained-${index}`}
                                type="radio"
                                checked={
                                  value?.deathcertificateobtained === false
                                }
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "settlementDeed",
                                    "deathcertificateobtained",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div
                            className="form-group  col-md-4"
                            style={{ marginBottom: 0 }}
                          >
                            <label className="label" style={{ padding: 0 }}>
                              Relationship Mentioned ?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <input
                                className="form-control"
                                name={
                                  "settlementDeedrelationshipMentioned" +
                                  value?.relationshipMentioned +
                                  index
                                }
                                type="text"
                                value={value?.relationshipMentioned}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "settlementDeed",
                                    "relationshipMentioned",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          {value?.condition === true && (
                            <>
                              <div
                                className="form-group  col-md-8"
                                style={{ marginBottom: 0 }}
                              >
                                <label className="label" style={{ padding: 0 }}>
                                  Mention Condition
                                </label>
                                <input
                                  className="form-control"
                                  name={
                                    "settlementDeedmentionCondition" +
                                    value?.mentionCondition +
                                    index
                                  }
                                  type="text"
                                  value={value?.mentionCondition}
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "settlementDeed",
                                      "mentionCondition",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </>
                          )}
                        </div>
                      );
                    })}
                </div>
                <hr />
                <div>
                  {this.getAddButton("Partition Deed", "partitionDeed", true)}
                  {data.partitionDeed &&
                    Array.isArray(data.partitionDeed) &&
                    data.partitionDeed.map((value, index) => {
                      return (
                        <>
                          <div className="row">
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Executant Derived by
                              </label>
                              <input
                                className="form-control"
                                name={
                                  "partitionDeedderivedBy" +
                                  value?.derivedBy +
                                  index
                                }
                                type="text"
                                value={value?.derivedBy}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "partitionDeed",
                                    "derivedBy",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Registered?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`partitionDeed-registered-${index}`}
                                  type="radio"
                                  checked={value?.registered === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "partitionDeed",
                                      "registered",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`partitionDeed-registered-${index}`}
                                  type="radio"
                                  checked={value?.registered === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "partitionDeed",
                                      "registered",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-3">
                              <label className="label" style={{ padding: 0 }}>
                                condition?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`partitionDeed-condition-${index}`}
                                  type="radio"
                                  checked={value?.condition === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "partitionDeed",
                                      "condition",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`partitionDeed-condition-${index}`}
                                  type="radio"
                                  checked={value?.condition === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "partitionDeed",
                                      "condition",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-3">
                              <label className="label" style={{ padding: 0 }}>
                                Death Certificate Obtained ?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`partitionDeed-partiondeathcertobtin-${index}`}
                                  type="radio"
                                  checked={
                                    value?.partiondeathcertobtin === true
                                  }
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "partitionDeed",
                                      "partiondeathcertobtin",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`partitionDeed-partiondeathcertobtin-${index}`}
                                  type="radio"
                                  checked={
                                    value?.partiondeathcertobtin === false
                                  }
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "partitionDeed",
                                      "partiondeathcertobtin",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-8">
                              <label className="label" style={{ padding: 0 }}>
                                Which Schedule/Item Alloted For Mortgage
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <input
                                  className="form-control"
                                  name={
                                    "partitionDeedpartionscheduleMortage" +
                                    value?.partionscheduleMortage +
                                    index
                                  }
                                  type="text"
                                  value={value?.partionscheduleMortage}
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "partitionDeed",
                                      "partionscheduleMortage",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-8">
                              <label className="label" style={{ padding: 0 }}>
                                Relationship Mentioned
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <input
                                  className="form-control"
                                  name={
                                    "partitionDeedpartionRelationship" +
                                    value?.partionRelationship +
                                    index
                                  }
                                  type="text"
                                  value={value?.partionRelationship}
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "partitionDeed",
                                      "partionRelationship",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            {this.checkOperation(
                              "partitionDeed",
                              value,
                              index,
                            ) && (
                              <div
                                className="form-group col-md-1"
                                style={{
                                  alignSelf: "center",
                                  fontSize: "initial",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.removeChild("partitionDeed", index)
                                }
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="feather icon-minus-circle"
                                />
                              </div>
                            )}
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                condition Fullfilled?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`partitionDeed-conditionFulfilled-${index}`}
                                  type="radio"
                                  checked={value?.conditionFulfilled === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "partitionDeed",
                                      "conditionFulfilled",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`partitionDeed-conditionFulfilled-${index}`}
                                  type="radio"
                                  checked={value?.conditionFulfilled === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "partitionDeed",
                                      "conditionFulfilled",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                {" "}
                                Simulatenous Copy Available?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                inline
                                label="Yes"
                                name={`partitionDeed-partionsimulatenous-${index}`}
                                type="radio"
                                checked={value?.partionsimulatenous === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "partitionDeed",
                                    "partionsimulatenous",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`partitionDeed-partionsimulatenous-${index}`}
                                type="radio"
                                checked={value?.partionsimulatenous === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "partitionDeed",
                                    "partionsimulatenous",
                                    false,
                                    index,
                                  )
                                }
                              />
                                {/* <input
                                  className="form-control"
                                  name={
                                    "partitionDeedpartionsimulatenous" +
                                    value?.partionsimulatenous +
                                    index
                                  }
                                  type="text"
                                  value={value?.partionsimulatenous}
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "partitionDeed",
                                      "partionsimulatenous",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                /> */}
                              </div>
                            </div>
                            <div className="form-group col-md-8">
                              <label className="label" style={{ padding: 0 }}>
                                Original Copy Available
                              </label>
                              <input
                                className="form-control"
                                name={
                                  "partitionDeedoriginalCopyAvailable" +
                                  value?.originalCopyAvailable +
                                  index
                                }
                                type="text"
                                value={value?.originalCopyAvailable}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "partitionDeed",
                                    "originalCopyAvailable",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                            <div></div>
                          </div>
                          {value?.condition === true && (
                            <>
                              <div className="row">
                                <div
                                  className="form-group col-md-12"
                                  style={{ marginBottom: 0 }}
                                >
                                  <label
                                    className="label"
                                    style={{ padding: 0 }}
                                  >
                                    Mention Condition
                                  </label>
                                  <input
                                    className="form-control"
                                    name={
                                      "partitionDeedmentionCondition" +
                                      value?.mentionCondition +
                                      index
                                    }
                                    type="text"
                                    value={value?.mentionCondition}
                                    onChange={(e) =>
                                      this.handleChildInputChange(
                                        "partitionDeed",
                                        "mentionCondition",
                                        e.target.value,
                                        index,
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      );
                    })}
                </div>
                <hr />
                <div>
                  {this.getAddButton("Will Deed", "willDeed", true)}
                  {data.willDeed &&
                    Array.isArray(data.willDeed) &&
                    data.willDeed.map((value, index) => {
                      return (
                        <div className="row">
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              Cerified Copy Verified?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                               <Form.Check
                                inline
                                label="Yes"
                                name={`willDeed-willdeedcertcopyverify-${index}`}
                                type="radio"
                                checked={value?.willdeedcertcopyverify === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "willDeed",
                                    "willdeedcertcopyverify",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`willDeed-willdeedcertcopyverify-${index}`}
                                type="radio"
                                checked={value?.willdeedcertcopyverify === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "willDeed",
                                    "willdeedcertcopyverify",
                                    false,
                                    index,
                                  )
                                }
                              />
                              {/* <input
                                className="form-control"
                                name={
                                  "willDeedwilldeedcertcopyverify" +
                                  value?.willdeedcertcopyverify +
                                  index
                                }
                                type="text"
                                value={value?.willdeedcertcopyverify}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "willDeed",
                                    "willdeedcertcopyverify",
                                    e.target.value,
                                    index,
                                  )
                                }
                              /> */}
                            </div>
                          </div>
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              Executant Derived by
                            </label>
                            <input
                              className="form-control"
                              name={
                                "willDeedderivedBy" + value?.derivedBy + index
                              }
                              type="text"
                              value={value?.derivedBy}
                              onChange={(e) =>
                                this.handleChildInputChange(
                                  "willDeed",
                                  "derivedBy",
                                  e.target.value,
                                  index,
                                )
                              }
                            />
                          </div>
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              Registered?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`willDeed-registered-${index}`}
                                type="radio"
                                checked={value?.registered === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "willDeed",
                                    "registered",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`willDeed-registered-${index}`}
                                type="radio"
                                checked={value?.registered === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "willDeed",
                                    "registered",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group  col-md-3">
                            <label className="label" style={{ padding: 0 }}>
                              condition?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`willDeed-condition-${index}`}
                                type="radio"
                                checked={value?.condition === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "willDeed",
                                    "condition",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`willDeed-condition-${index}`}
                                type="radio"
                                checked={value?.condition === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "willDeed",
                                    "condition",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          {this.checkOperation("willDeed", value, index) && (
                            <div
                              className="form-group col-md-1"
                              style={{
                                alignSelf: "center",
                                fontSize: "initial",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.removeChild("willDeed", index)
                              }
                            >
                              <i
                                style={{ color: "red" }}
                                className="feather icon-minus-circle"
                              />
                            </div>
                          )}
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              condition Fullfilled?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`willDeed-conditionFulfilled-${index}`}
                                type="radio"
                                checked={value?.conditionFulfilled === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "willDeed",
                                    "conditionFulfilled",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`willDeed-conditionFulfilled-${index}`}
                                type="radio"
                                checked={value?.conditionFulfilled === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "willDeed",
                                    "conditionFulfilled",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              Death Certificate Obtained
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`willDeed-willdeaddeathcert-${index}`}
                                type="radio"
                                checked={value?.willdeaddeathcert === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "willDeed",
                                    "willdeaddeathcert",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`willDeed-willdeaddeathcert-${index}`}
                                type="radio"
                                checked={value?.willdeaddeathcert === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "willDeed",
                                    "willdeaddeathcert",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              Relationship Mentioned
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <input
                                className="form-control"
                                name={
                                  "willDeedwilldeadreationship" +
                                  value?.willdeadreationship +
                                  index
                                }
                                type="text"
                                value={value?.willdeadreationship}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "willDeed",
                                    "willdeadreationship",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          {value?.condition === true && (
                            <>
                              <div
                                className="form-group  col-md-8"
                                style={{ marginBottom: 0 }}
                              >
                                <label className="label" style={{ padding: 0 }}>
                                  Mention Condition
                                </label>
                                <input
                                  className="form-control"
                                  name={
                                    "willDeedmentionCondition" +
                                    value?.mentionCondition +
                                    index
                                  }
                                  type="text"
                                  value={value?.mentionCondition}
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "willDeed",
                                      "mentionCondition",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </>
                          )}
                        </div>
                      );
                    })}
                </div>
                <hr />
                <div>
                  {this.getAddButton("Lease Deed", "leaseDeed", true)}
                  {data.leaseDeed &&
                    Array.isArray(data.leaseDeed) &&
                    data.leaseDeed.map((value, index) => {
                      return (
                        <div className="row">
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              Lease Period From Date
                            </label>
                            <input
                              className="form-control"
                              name={
                                "leaseDeedleasePeriodFromDate" +
                                value?.leasePeriodFromDate +
                                index
                              }
                              type="text"
                              value={value?.leasePeriodFromDate}
                              onChange={(e) =>
                                this.handleChildInputChange(
                                  "leaseDeed",
                                  "leasePeriodFromDate",
                                  e.target.value,
                                  index,
                                )
                              }
                            />
                          </div>
                          <div className="form-group  col-md-4">
                            <label className="label" style={{ padding: 0 }}>
                              Lease Period To Date
                            </label>
                            <input
                              className="form-control"
                              name={
                                "leaseDeedleasePeriodToDate" +
                                value?.leasePeriodToDate +
                                index
                              }
                              type="text"
                              value={value?.leasePeriodToDate}
                              onChange={(e) =>
                                this.handleChildInputChange(
                                  "leaseDeed",
                                  "leasePeriodToDate",
                                  e.target.value,
                                  index,
                                )
                              }
                            />
                          </div>
                          <div className="form-group  col-md-3">
                            <label className="label" style={{ padding: 0 }}>
                              Is there a word to empower mortgage in Lease Deed
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`leaseDeed-leaseDeedempowermortage-${index}`}
                                type="radio"
                                checked={
                                  value?.leaseDeedempowermortage === true
                                }
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "leaseDeed",
                                    "leaseDeedempowermortage",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`leaseDeed-leaseDeedempowermortage-${index}`}
                                type="radio"
                                checked={
                                  value?.leaseDeedempowermortage === false
                                }
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "leaseDeed",
                                    "leaseDeedempowermortage",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group  col-md-3">
                            <label className="label" style={{ padding: 0 }}>
                              NOC Available?
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`leaseDeed-nocAvailable-${index}`}
                                type="radio"
                                checked={value?.nocAvailable === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "leaseDeed",
                                    "nocAvailable",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`leaseDeed-nocAvailable-${index}`}
                                type="radio"
                                checked={value?.nocAvailable === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "leaseDeed",
                                    "nocAvailable",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group  col-md-3">
                            <label className="label" style={{ padding: 0 }}>
                              Lease Cancellation Available
                            </label>
                            <div className="row" style={{ marginLeft: 0 }}>
                              <Form.Check
                                inline
                                label="Yes"
                                name={`leaseDeed-leaseDeedCancellation-${index}`}
                                type="radio"
                                checked={value?.leaseDeedCancellation === true}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "leaseDeed",
                                    "leaseDeedCancellation",
                                    true,
                                    index,
                                  )
                                }
                              />
                              <Form.Check
                                inline
                                label="No"
                                name={`leaseDeed-leaseDeedCancellation-${index}`}
                                type="radio"
                                checked={value?.leaseDeedCancellation === false}
                                onChange={() =>
                                  this.handleChildRadioChange(
                                    "leaseDeed",
                                    "leaseDeedCancellation",
                                    false,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          {this.checkOperation("leaseDeed", value, index) && (
                            <div
                              className="form-group col-md-1"
                              style={{
                                alignSelf: "center",
                                fontSize: "initial",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.removeChild("leaseDeed", index)
                              }
                            >
                              <i
                                style={{ color: "red" }}
                                className="feather icon-minus-circle"
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
                <hr />

                <div>
                  {this.getAddButton(
                    "Release or Partition Release Deed",
                    "releaseDeed",
                    true,
                  )}
                  {data.releaseDeed &&
                    Array.isArray(data.releaseDeed) &&
                    data.releaseDeed.map((value, index) => {
                      return (
                        <>
                          <div className="row mb-10">
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Executant Derived by
                              </label>
                              <input
                                className="form-control"
                                name={
                                  "releaseDeedderivedBy" +
                                  value?.derivedBy +
                                  index
                                }
                                type="text"
                                value={value?.derivedBy}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "releaseDeed",
                                    "derivedBy",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                            <div className="form-group  col-md-3">
                              <label className="label" style={{ padding: 0 }}>
                                Registered?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`releaseDeed-registered-${index}`}
                                  type="radio"
                                  checked={value?.registered === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "releaseDeed",
                                      "registered",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`releaseDeed-registered-${index}`}
                                  type="radio"
                                  checked={value?.registered === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "releaseDeed",
                                      "registered",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-3">
                              <label className="label" style={{ padding: 0 }}>
                                Condition?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`releaseDeed-condition-${index}`}
                                  type="radio"
                                  checked={value?.condition === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "releaseDeed",
                                      "condition",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`releaseDeed-condition-${index}`}
                                  type="radio"
                                  checked={value?.condition === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "releaseDeed",
                                      "condition",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            {this.checkOperation(
                              "releaseDeed",
                              value,
                              index,
                            ) && (
                              <div
                                className="form-group col-md-1"
                                style={{
                                  alignSelf: "center",
                                  fontSize: "initial",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.removeChild("releaseDeed", index)
                                }
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="feather icon-minus-circle"
                                />
                              </div>
                            )}
                          </div>
                          <div className="row mb-10">
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Condition Fulfilled?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`releaseDeed-fulFilled-${index}`}
                                  type="radio"
                                  checked={value?.fulFilled === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "releaseDeed",
                                      "fulFilled",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`releaseDeed-fulFilled-${index}`}
                                  type="radio"
                                  checked={value?.fulFilled === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "releaseDeed",
                                      "fulFilled",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Death Certificate Obtained{" "}
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`releaseDeed-deatcertficate-${index}`}
                                  type="radio"
                                  checked={value?.deatcertficate === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "releaseDeed",
                                      "deatcertficate",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`releaseDeed-deatcertficate-${index}`}
                                  type="radio"
                                  checked={value?.deatcertficate === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "releaseDeed",
                                      "deatcertficate",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Relationship Mentioned{" "}
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <input
                                  className="form-control"
                                  name={
                                    "releaseDeedrelationShipmentioned" +
                                    value?.relationShipmentioned +
                                    index
                                  }
                                  type="text"
                                  value={value?.relationShipmentioned}
                                  onChange={(e) =>
                                    this.handleChildInputChange(
                                      "releaseDeed",
                                      "relationShipmentioned",
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Property Share? <span>Eg: 1/3, 4/7</span>
                              </label>
                              <input
                                className="form-control"
                                name={
                                  "releaseDeedpropertyshare" +
                                  value?.propertyshare +
                                  index
                                }
                                type="text"
                                value={value?.propertyshare}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "releaseDeed",
                                    "propertyshare",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                          {value?.condition === true && (
                            <>
                              <div className="row mb-10">
                                <div className="form-group  col-md-6">
                                  <label
                                    className="label"
                                    style={{ padding: 0 }}
                                  >
                                    Mention Condition
                                  </label>
                                  <input
                                    className="form-control"
                                    name={
                                      "releaseDeedmentionCondition" +
                                      value?.mentionCondition +
                                      index
                                    }
                                    type="text"
                                    value={value?.mentionCondition}
                                    onChange={(e) =>
                                      this.handleChildInputChange(
                                        "releaseDeed",
                                        "mentionCondition",
                                        e.target.value,
                                        index,
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      );
                    })}
                </div>
                <hr />

                <div>
                  {this.getAddButton(
                    "Rectification Deed",
                    "rectificationDeed",
                    true,
                  )}
                  {data.rectificationDeed &&
                    Array.isArray(data.rectificationDeed) &&
                    data.rectificationDeed.map((value, index) => {
                      return (
                        <>
                          <div className="row mb-10">
                            <div className="form-group  col-md-6">
                              <label className="label" style={{ padding: 0 }}>
                                Executant Derived by
                              </label>
                              <input
                                className="form-control"
                                name={
                                  "rectificationDeedderivedBy" +
                                  value?.derivedBy +
                                  index
                                }
                                type="text"
                                value={value?.derivedBy}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "rectificationDeed",
                                    "derivedBy",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Registered?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`rectificationDeed-registered-${index}`}
                                  type="radio"
                                  checked={value?.registered === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "rectificationDeed",
                                      "registered",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`rectificationDeed-registered-${index}`}
                                  type="radio"
                                  checked={value?.registered === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "rectificationDeed",
                                      "registered",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            {this.checkOperation(
                              "rectificationDeed",
                              value,
                              index,
                            ) && (
                              <div
                                className="form-group col-md-1"
                                style={{
                                  alignSelf: "center",
                                  fontSize: "initial",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.removeChild("rectificationDeed", index)
                                }
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="feather icon-minus-circle"
                                />
                              </div>
                            )}
                          </div>
                          <div className="row mb-10">
                            <div className="form-group  col-md-6">
                              <label className="label" style={{ padding: 0 }}>
                                Wrongly Mentioned Details
                              </label>
                              <input
                                className="form-control"
                                name={
                                  "rectificationDeedmentionDetails" +
                                  value?.mentionDetails +
                                  index
                                }
                                type="text"
                                value={value?.mentionDetails}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "rectificationDeed",
                                    "mentionDetails",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                            <div className="form-group  col-md-6">
                              <label className="label" style={{ padding: 0 }}>
                                Correct Details
                              </label>
                              <input
                                className="form-control"
                                name={
                                  "rectificationDeedcorrectDetails" +
                                  value?.correctDetails +
                                  index
                                }
                                type="text"
                                value={value?.correctDetails}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "rectificationDeed",
                                    "correctDetails",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                        </>
                      );
                    })}
                </div>
                <hr />

                <div>
                  {this.getAddButton("Consent Deed", "consentDeed", true)}
                  {data.consentDeed &&
                    Array.isArray(data.consentDeed) &&
                    data.consentDeed.map((value, index) => {
                      return (
                        <>
                          <div className="row mb-10">
                            <div className="form-group  col-md-6">
                              <label className="label" style={{ padding: 0 }}>
                                Executant Derived by
                              </label>
                              <input
                                className="form-control"
                                name={
                                  "consentDeedderivedBy" +
                                  value?.derivedBy +
                                  index
                                }
                                type="text"
                                value={value?.derivedBy}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "consentDeed",
                                    "derivedBy",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Registered?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`consentDeed-registered-${index}`}
                                  type="radio"
                                  checked={value?.registered === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "consentDeed",
                                      "registered",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`consentDeed-registered-${index}`}
                                  type="radio"
                                  checked={value?.registered === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "consentDeed",
                                      "registered",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Age checked with Aadharcard
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`consentDeed-agecheckAadhar-${index}`}
                                  type="radio"
                                  checked={value?.agecheckAadhar === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "consentDeed",
                                      "agecheckAadhar",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`consentDeed-agecheckAadhar-${index}`}
                                  type="radio"
                                  checked={value?.agecheckAadhar === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "consentDeed",
                                      "agecheckAadhar",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            {this.checkOperation(
                              "consentDeed",
                              value,
                              index,
                            ) && (
                              <div
                                className="form-group col-md-1"
                                style={{
                                  alignSelf: "center",
                                  fontSize: "initial",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.removeChild("consentDeed", index)
                                }
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="feather icon-minus-circle"
                                />
                              </div>
                            )}
                          </div>
                          <div className="row mb-10">
                            <div className="form-group  col-md-6">
                              <label className="label" style={{ padding: 0 }}>
                                Reason for Consent Deed
                              </label>
                              <input
                                className="form-control"
                                name={
                                  "consentDeedreason" + value?.reason + index
                                }
                                type="text"
                                value={value?.reason}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "consentDeed",
                                    "reason",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                          </div>
                        </>
                      );
                    })}
                </div>
                <hr />

                <div>
                  {" "}
                  {this.getAddButton(
                    "Missing Document",
                    "missingDocument",
                    true,
                  )}
                  {data.missingDocument &&
                    Array.isArray(data.missingDocument) &&
                    data.missingDocument.map((value, index) => {
                      return (
                        <>
                          <div className="row mb-10">
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Police Complaint
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`missingDocument-policeComplaint-${index}`}
                                  type="radio"
                                  checked={value?.policeComplaint === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "missingDocument",
                                      "policeComplaint",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`missingDocument-policeComplaint-${index}`}
                                  type="radio"
                                  checked={value?.policeComplaint === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "missingDocument",
                                      "policeComplaint",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Paper Ad ( Tamil/ English)
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`missingDocument-paperAd-${index}`}
                                  type="radio"
                                  checked={value?.paperAd === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "missingDocument",
                                      "paperAd",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`missingDocument-paperAd-${index}`}
                                  type="radio"
                                  checked={value?.paperAd === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "missingDocument",
                                      "paperAd",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                Non Tracable certificate by Police
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`missingDocument-tracableCertificate-${index}`}
                                  type="radio"
                                  checked={value?.tracableCertificate === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "missingDocument",
                                      "tracableCertificate",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`missingDocument-tracableCertificate-${index}`}
                                  type="radio"
                                  checked={value?.tracableCertificate === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "missingDocument",
                                      "tracableCertificate",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-4">
                              <label className="label" style={{ padding: 0 }}>
                                No Claim Certificate by Advocate
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`missingDocument-NoClaimcertificate-${index}`}
                                  type="radio"
                                  checked={value?.NoClaimcertificate === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "missingDocument",
                                      "NoClaimcertificate",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`missingDocument-NoClaimcertificate-${index}`}
                                  type="radio"
                                  checked={value?.NoClaimcertificate === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "missingDocument",
                                      "NoClaimcertificate",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>

                            {this.checkOperation(
                              "missingDocument",
                              value,
                              index,
                            ) && (
                              <div
                                className="form-group col-md-1"
                                style={{
                                  alignSelf: "center",
                                  fontSize: "initial",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.removeChild("missingDocument", index)
                                }
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="feather icon-minus-circle"
                                />
                              </div>
                            )}
                          </div>
                        </>
                      );
                    })}
                </div>
                <hr />

                <div>
                  {this.getAddButton(
                    "General Power Of Attorney Deed",
                    "attorneyDeed",
                    true,
                  )}
                  {data.attorneyDeed &&
                    Array.isArray(data.attorneyDeed) &&
                    data.attorneyDeed.map((value, index) => {
                      return (
                        <>
                          <div className="row mb-10">
                            <div className="form-group  col-md-6">
                              <label className="label" style={{ padding: 0 }}>
                                Executant Derived by
                              </label>
                              <input
                                className="form-control"
                                name={
                                  "attorneyDeedderivedBy" +
                                  value?.derivedBy +
                                  index
                                }
                                type="text"
                                value={value?.derivedBy}
                                onChange={(e) =>
                                  this.handleChildInputChange(
                                    "attorneyDeed",
                                    "derivedBy",
                                    e.target.value,
                                    index,
                                  )
                                }
                              />
                            </div>
                            <div className="form-group  col-md-5">
                              <label className="label" style={{ padding: 0 }}>
                                Registered?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`attorneyDeed-registered-${index}`}
                                  type="radio"
                                  checked={value?.registered === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "registered",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`attorneyDeed-registered-${index}`}
                                  type="radio"
                                  checked={value?.registered === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "registered",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            {this.checkOperation(
                              "attorneyDeed",
                              value,
                              index,
                            ) && (
                              <div
                                className="form-group col-md-1"
                                style={{
                                  alignSelf: "center",
                                  fontSize: "initial",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.removeChild("attorneyDeed", index)
                                }
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="feather icon-minus-circle"
                                />
                              </div>
                            )}
                          </div>
                          <div className="row mb-10">
                            <div className="form-group  col-md-6">
                              <label className="label" style={{ padding: 0 }}>
                                Is in force?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`attorneyDeed-isInForce-${index}`}
                                  type="radio"
                                  checked={value?.isInForce === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "isInForce",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`attorneyDeed-isInForce-${index}`}
                                  type="radio"
                                  checked={value?.isInForce === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "isInForce",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-6">
                              <label className="label" style={{ padding: 0 }}>
                                Is there a word to empower mortgage in power
                                Document
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`attorneyDeed-attorneyDeedmortage-${index}`}
                                  type="radio"
                                  checked={value?.attorneyDeedmortage === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "attorneyDeedmortage",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`attorneyDeed-attorneyDeedmortage-${index}`}
                                  type="radio"
                                  checked={value?.attorneyDeedmortage === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "attorneyDeedmortage",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-6">
                              <label className="label" style={{ padding: 0 }}>
                                Is certified copy available?
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`attorneyDeed-isCertifiedCopyAvailable-${index}`}
                                  type="radio"
                                  checked={
                                    value?.isCertifiedCopyAvailable === true
                                  }
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "isCertifiedCopyAvailable",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`attorneyDeed-isCertifiedCopyAvailable-${index}`}
                                  type="radio"
                                  checked={
                                    value?.isCertifiedCopyAvailable === false
                                  }
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "isCertifiedCopyAvailable",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-6">
                              <label className="label" style={{ padding: 0 }}>
                                Sale Receipt -Subsequent Deed available or not
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`attorneyDeed-attorneyDeedsaleReceipt-${index}`}
                                  type="radio"
                                  checked={
                                    value?.attorneyDeedsaleReceipt === true
                                  }
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "attorneyDeedsaleReceipt",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`attorneyDeed-attorneyDeedsaleReceipt-${index}`}
                                  type="radio"
                                  checked={
                                    value?.attorneyDeedsaleReceipt === false
                                  }
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "attorneyDeedsaleReceipt",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group  col-md-6">
                              <label className="label" style={{ padding: 0 }}>
                                Life Certificate is available for current
                                Transfer(30 days Validity)
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={`attorneyDeed-attorneyLifecert-${index}`}
                                  type="radio"
                                  checked={value?.attorneyLifecert === true}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "attorneyLifecert",
                                      true,
                                      index,
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={`attorneyDeed-attorneyLifecert-${index}`}
                                  type="radio"
                                  checked={value?.attorneyLifecert === false}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "attorneyDeed",
                                      "attorneyLifecert",
                                      false,
                                      index,
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                </div>
                <hr />
                <div>
                  <h6>
                    <b>Plot Regularization</b>
                  </h6>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "20px",
                    }}
                  >
                    <Form.Check
                      inline
                      label="Yes"
                      name="ishowplotregulationstatus"
                      type="radio"
                      checked={data.ishowplotregulationstatus === true}
                      onChange={() => {
                        const newData = { ...data };
                        newData.ishowplotregulationstatus = true;
                        this.changeBgColor();
                        newData.bgColor = "lightgreen";
                        this.props.handleDeedChange(newData);
                        this.setState({
                          isUpdateAvailable: !this.state.isUpdateAvailable,
                        });
                      }}
                      style={{ marginRight: "15px" }}
                    />
                    <Form.Check
                      inline
                      label="No"
                      name="ishowplotregulationstatus"
                      type="radio"
                      checked={data.ishowplotregulationstatus === false}
                      onChange={() => {
                        const newData = { ...data };
                        newData.ishowplotregulationstatus = false;
                        this.changeBgColor();
                        newData.bgColor = "lightgreen";
                        this.props.handleDeedChange(newData);
                        this.setState({
                          isUpdateAvailable: !this.state.isUpdateAvailable,
                        });
                      }}
                    />
                  </div>
                  <div className="row mb-10">
                    <div className="col-md-12">
                      <label className="label" style={{ padding: 0 }}>
                        Is Title Deed Registered After 30-09-2016?
                      </label>
                    </div>
                    <div className="col-md-12">
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="isDeedRegisteredAfter30_9_2016"
                          type="radio"
                          checked={
                            data.plotRegularization
                              .isDeedRegisteredAfter30_9_2016 === true
                          }
                          onChange={() =>
                            this.handleChildRadioChange(
                              "plotRegularization",
                              "isDeedRegisteredAfter30_9_2016",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="isDeedRegisteredAfter30_9_2016"
                          type="radio"
                          checked={
                            data.plotRegularization
                              .isDeedRegisteredAfter30_9_2016 === false
                          }
                          onChange={() =>
                            this.handleChildRadioChange(
                              "plotRegularization",
                              "isDeedRegisteredAfter30_9_2016",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-10">
                    <div className="col-md-12">
                      <label className="label" style={{ padding: 0 }}>
                        Is Plot Regulation Obtained?
                      </label>
                    </div>
                    <div className="col-md-3">
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="isPlotObtained"
                          type="radio"
                          checked={
                            data.plotRegularization.isPlotObtained === true
                          }
                          onChange={() =>
                            this.handleChildRadioChange(
                              "plotRegularization",
                              "isPlotObtained",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="isPlotObtained"
                          type="radio"
                          checked={
                            data.plotRegularization.isPlotObtained === false
                          }
                          onChange={() =>
                            this.handleChildRadioChange(
                              "plotRegularization",
                              "isPlotObtained",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <h6>
                    <b>Adjudication Power Deed</b>
                  </h6>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "20px",
                    }}
                  >
                    <Form.Check
                      inline
                      label="Yes"
                      name="ishowAdjudicationstatus"
                      type="radio"
                      checked={data.ishowAdjudicationstatus === true}
                      onChange={() => {
                        const newData = { ...data };
                        newData.ishowAdjudicationstatus = true;
                        this.changeBgColor();
                        newData.bgColor = "lightgreen";
                        this.props.handleDeedChange(newData);
                        this.setState({
                          isUpdateAvailable: !this.state.isUpdateAvailable,
                        });
                      }}
                      style={{ marginRight: "15px" }}
                    />
                    <Form.Check
                      inline
                      label="No"
                      name="ishowAdjudicationstatus"
                      type="radio"
                      checked={data.ishowAdjudicationstatus === false}
                      onChange={() => {
                        const newData = { ...data };
                        newData.ishowAdjudicationstatus = false;
                        this.changeBgColor();
                        newData.bgColor = "lightgreen";
                        this.props.handleDeedChange(newData);
                        this.setState({
                          isUpdateAvailable: !this.state.isUpdateAvailable,
                        });
                      }}
                    />
                  </div>

                  <div className="row mb-10">
                    <div className="col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Is Adjudication Power Registered?
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="isForiegnPowerRegistered"
                          type="radio"
                          checked={
                            data.foriegnPower.isForiegnPowerRegistered === true
                          }
                          onChange={() =>
                            this.handleChildRadioChange(
                              "foriegnPower",
                              "isForiegnPowerRegistered",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="isForiegnPowerRegistered"
                          type="radio"
                          checked={
                            data.foriegnPower.isForiegnPowerRegistered === false
                          }
                          onChange={() =>
                            this.handleChildRadioChange(
                              "foriegnPower",
                              "isForiegnPowerRegistered",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    {data.foriegnPower.isForiegnPowerRegistered === true && (
                      <div className="col-md-6">
                        <label className="label" style={{ padding: 0 }}>
                          Document Number
                        </label>
                        <input
                          className="form-control"
                          name="docNo"
                          type="text"
                          value={data.foriegnPower.docNo}
                          onChange={(e) =>
                            this.handleChildInputChange(
                              "foriegnPower",
                              "docNo",
                              e.target.value,
                            )
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
                <hr />
                <div>
                  <h6>
                    <b>Power To Mortgage</b>
                  </h6>
                  <div className="row mb-10">
                    <div className="col-md-12">
                      <label className="label" style={{ padding: 0 }}>
                        Is there a word to Empowerr to Mortgage
                      </label>
                    </div>
                    <div className="col-md-3">
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="mortgageInPowerDoc"
                          type="radio"
                          checked={data.mortgageInPowerDoc === true}
                          onChange={() =>
                            this.handleChange("mortgageInPowerDoc", true)
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="mortgageInPowerDoc"
                          type="radio"
                          checked={data.mortgageInPowerDoc === false}
                          onChange={() =>
                            this.handleChange("mortgageInPowerDoc", false)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <h6>
                    <b>Gazette</b>
                  </h6>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "20px",
                    }}
                  >
                    <Form.Check
                      inline
                      label="Yes"
                      name="ishowGazettestatus"
                      type="radio"
                      checked={data.ishowGazettestatus === true}
                      onChange={() => {
                        const newData = { ...data };
                        newData.ishowGazettestatus = true;
                        this.changeBgColor();
                        newData.bgColor = "lightgreen";
                        this.props.handleDeedChange(newData);
                        this.setState({
                          isUpdateAvailable: !this.state.isUpdateAvailable,
                        });
                      }}
                      style={{ marginRight: "15px" }}
                    />
                    <Form.Check
                      inline
                      label="No"
                      name="ishowGazettestatus"
                      type="radio"
                      checked={data.ishowGazettestatus === false}
                      onChange={() => {
                        const newData = { ...data };
                        newData.ishowGazettestatus = false;
                        this.changeBgColor();
                        newData.bgColor = "lightgreen";
                        this.props.handleDeedChange(newData);
                        this.setState({
                          isUpdateAvailable: !this.state.isUpdateAvailable,
                        });
                      }}
                    />
                  </div>
                  {/* {data?.gazetteofDoc ? ( */}
                  <>
                    <div className="row mb-10">
                      <div className="col-md-6">
                        <label className="label" style={{ padding: 0 }}>
                          Is Name Changed(Gazette)
                        </label>
                      </div>
                      <div className="col-md-6">
                        <div className="row" style={{ marginLeft: 0 }}>
                          <Form.Check
                            inline
                            label="Yes"
                            name="isNameChanged"
                            type="radio"
                            checked={data.gazetteofDoc?.isNameChanged === true}
                            onChange={() =>
                              this.handleChildRadioChange(
                                "gazetteofDoc",
                                "isNameChanged",
                                true,
                              )
                            }
                          />
                          <Form.Check
                            inline
                            label="No"
                            name="isNameChanged"
                            type="radio"
                            checked={data.gazetteofDoc?.isNameChanged === false}
                            onChange={() =>
                              this.handleChildRadioChange(
                                "gazetteofDoc",
                                "isNameChanged",
                                false,
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-10">
                      <div className="col-md-6">
                        <label className="label" style={{ padding: 0 }}>
                          Gazette Publication available
                        </label>
                      </div>
                      <div className="col-md-6">
                        <div className="row" style={{ marginLeft: 0 }}>
                          <Form.Check
                            inline
                            label="Yes"
                            name="gazettePublication"
                            type="radio"
                            checked={
                              data.gazetteofDoc?.gazettePublication === true
                            }
                            onChange={() =>
                              this.handleChildRadioChange(
                                "gazetteofDoc",
                                "gazettePublication",
                                true,
                              )
                            }
                          />
                          <Form.Check
                            inline
                            label="No"
                            name="gazettePublication"
                            type="radio"
                            checked={
                              data.gazetteofDoc?.gazettePublication === false
                            }
                            onChange={() =>
                              this.handleChildRadioChange(
                                "gazetteofDoc",
                                "gazettePublication",
                                false,
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-10">
                      <div className="col-md-6">
                        <label className="label" style={{ padding: 0 }}>
                          Name Changed Certifcate by Tahsildar/VAO
                        </label>
                      </div>
                      <div className="col-md-6">
                        <div className="row" style={{ marginLeft: 0 }}>
                          <Form.Check
                            inline
                            label="Yes"
                            name="NameChangedbythasildar"
                            type="radio"
                            checked={
                              data.gazetteofDoc?.NameChangedbythasildar === true
                            }
                            onChange={() =>
                              this.handleChildRadioChange(
                                "gazetteofDoc",
                                "NameChangedbythasildar",
                                true,
                              )
                            }
                          />
                          <Form.Check
                            inline
                            label="No"
                            name="NameChangedbythasildar"
                            type="radio"
                            checked={
                              data.gazetteofDoc?.NameChangedbythasildar ===
                              false
                            }
                            onChange={() =>
                              this.handleChildRadioChange(
                                "gazetteofDoc",
                                "NameChangedbythasildar",
                                false,
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-10">
                      <div className="col-md-6">
                        <label className="label" style={{ padding: 0 }}>
                          Indementy Bond/Affidavit
                        </label>
                      </div>
                      <div className="col-md-6">
                        <div className="row" style={{ marginLeft: 0 }}>
                          <Form.Check
                            inline
                            label="Yes"
                            name="IndementyBond"
                            type="radio"
                            checked={data.gazetteofDoc?.IndementyBond === true}
                            onChange={() =>
                              this.handleChildRadioChange(
                                "gazetteofDoc",
                                "IndementyBond",
                                true,
                              )
                            }
                          />
                          <Form.Check
                            inline
                            label="No"
                            name="IndementyBond"
                            type="radio"
                            checked={data.gazetteofDoc?.IndementyBond === false}
                            onChange={() =>
                              this.handleChildRadioChange(
                                "gazetteofDoc",
                                "IndementyBond",
                                false,
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                    {data.gazetteofDoc?.isNameChanged && (
                      <div className="row mb-10">
                        <div className="col-md-6">
                          <label className="label" style={{ padding: 0 }}>
                            Name Changed Document(s) List
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            className="form-control"
                            name="docList"
                            type="text"
                            value={data.gazetteofDoc?.docList || ""}
                            onChange={(e) =>
                              this.handleChildInputChange(
                                "gazetteofDoc",
                                "docList",
                                e.target.value,
                              )
                            }
                          />
                        </div>
                      </div>
                    )}
                  </>
                  {/* ) : (
                    ""
                  )} */}
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default Deed;
